import { Helmet } from "react-helmet-async";

interface SEOParams {
  type: "article" | "product" | "website";
  title: string;
  description: string;
  imageUrl?: string;
}

export const SEO = ({ type, title, description, imageUrl }: SEOParams) => (
  <Helmet>
    <title>{title}</title>
    <meta property="og:type" content={type} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {!imageUrl ? null : <meta property="og:image" content={imageUrl} />}
  </Helmet>
);